
/* styles */
require("!!../../../../../../../../azure/movemais.client/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/style-rewriter?id=data-v-50191b96&scoped=true!sass-loader?sourceMap!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=styles&index=0!./transfer-shipper-voucher-detail.vue")

var Component = require("!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./transfer-shipper-voucher-detail.js"),
  /* template */
  require("!!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-50191b96!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./transfer-shipper-voucher-detail.vue"),
  /* scopeId */
  "data-v-50191b96",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/account/shipper/transfer-shipper-voucher-detail.vue
// module id = 1945
// module chunks = 1